module.exports = __webpack_public_path__ + "img/33.51f0a4d9.jpg";